import Vue from"vue";Vue.filter("attachText",(function(e,t){return console.warn("attachText is a deprecated vue filter!"),t+e}));